<template>
    <template v-if="pendingTerm">
        <vx-alert shadow data-test="terms-banner-alert" color="info" :closeable="false">
            <div class="flex flex-col gap-2">
                <div class="font-extrabold text-base">{{ pendingTerm.title }}</div>
                <div>
                    <template v-if="isOwner">
                        <template v-if="hasTakenEffect">
                            New Terms &amp; Conditions are now in effect. You as the group Owner must accept these terms
                            to restore service.
                        </template>
                        <template v-else>
                            New Terms &amp; Conditions take effect on {{ formattedEffectiveAt }}. You as the group Owner
                            must accept these terms to avoid interruptions in service.
                        </template>
                    </template>
                    <template v-else>
                        <template v-if="hasTakenEffect">
                            New Terms &amp; Conditions are now in effect. Your group Owner must accept these terms to
                            restore service.
                        </template>
                        <template v-else>
                            New Terms &amp; Conditions take effect on {{ formattedEffectiveAt }}. Your group Owner must
                            accept these terms to avoid interruptions in service.
                        </template>
                    </template>
                </div>
            </div>
            <template v-slot:right>
                <vx-button
                    v-if="isOwner"
                    data-test="terms-review-link"
                    color="info"
                    :href="`/settings/teams/${teamId}#/group-terms`"
                >
                    Review &amp; Accept
                </vx-button>
                <vx-button
                    v-else-if="owner"
                    data-test="terms-contact-owner-link"
                    color="info"
                    :href="`mailto:${owner.email}`"
                >
                    Contact {{ owner.name }}
                </vx-button>
            </template>
        </vx-alert>
    </template>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue';
import { VxAlert, VxButton } from '@voxie/frontend-components';
import termsClient from '~/services/termsClient';
import type { GroupOwnerContact, Term } from '~/services/termsClient.types';
import { shortDate } from '~/utils/date';
import dayjs from '~/utils/dayjs';

const teamId = Spark.state.currentTeam.id;
const groupId = Spark.state.currentGroup?.group_id ?? null;
const isOwner = Spark.roleOnCurrentGroup === 'owner';

const pendingTerm = ref<Term | null>(null);
const owner = ref<GroupOwnerContact | null>(null);

const formattedEffectiveAt = computed(() => {
    if (!pendingTerm.value) {
        return '';
    }
    return shortDate(pendingTerm.value.effective_at);
});

const hasTakenEffect = computed(() =>
    pendingTerm.value ? dayjs.utc(pendingTerm.value.effective_at).isBefore(dayjs()) : false
);

const loadActive = async () => {
    if (!groupId) {
        return;
    }

    try {
        const { data } = await termsClient.getActiveTerm(teamId, groupId);
        pendingTerm.value = data.accepted ? null : data.term;
        owner.value = data.owner;
    } catch (error) {
        console.error('Failed to load active T&C', error);
        pendingTerm.value = null;
        owner.value = null;
    }
};

onMounted(() => {
    loadActive();
});
</script>
